import React from "react";
import PropTypes from "prop-types";
import {
    Drawer,
    Row,
    Col,
    Descriptions,
    Card,
    Empty,
    Spin,
    message
} from "antd";
import { CompanyService } from "../../services";

class MeetingHistory extends React.Component {
    state = {
        meetingData: [],
        meetingLoader: false
    };
    componentDidMount() {
        this.setState({
            meetingLoader: true
        })
        CompanyService.getMinutesOfMeeting(this.props.umsCompanyId)
            .then((resp) => {
                this.setState({
                    meetingData: resp.data.results,
                    meetingLoader: false
                })
            })
            .catch((err) => {
                message.error(err.toString())
                this.setState({
                    meetingLoader: false
                })
            })
    }


    closeModal = () => {
        this.props.closeModal()
    }

    render() {
        return (
            <Drawer
                title={"Meeting History"}
                closable
                visible={this.props.visible}
                onClose={this.closeModal}
                placement={"right"}
                width={"60vw"}
                footer={null}
            >
                <Row><Spin spinning={this.state.meetingLoader}>
                    <Col span={24}>
                        <Row>
                            {!this.state.meetingData.length && <Empty />}
                            {this.state.meetingData.map(_ => <Col
                                span={24}
                                style={{
                                    flexGrow: 1,
                                    // minHeight: "63vh",
                                    maxHeight: "65vh",
                                    overflowY: "auto",
                                    marginBottom: "15px"
                                }}
                                className={"p-5"}
                            >
                                <h3>{_.meeting_title}</h3>
                                <h4>{_.meeting_date}</h4>
                                <Row className="mt-10">
                                    <Card>
                                        <Col span="24">
                                            <Descriptions size={this.state.size}>
                                                <Descriptions.Item label="Meeting Type">{_.meeting_type}</Descriptions.Item>
                                                <Descriptions.Item label="Attendee Name">{_.name_of_attendee}</Descriptions.Item>
                                            </Descriptions>
                                        </Col>
                                        <Col span="24">
                                            <Descriptions size={this.state.size}>
                                                <Descriptions.Item label="Meeting Details">{_.meeting_details}</Descriptions.Item>
                                            </Descriptions>
                                        </Col>
                                        <Col span="24">
                                            <Descriptions size={this.state.size}>
                                                <Descriptions.Item label="Supporting Documents">
                                                   { <Row className="mt-10">
                                                        {_.supporting_document ? <img width={"30%"} src={_.supporting_document} className="mb-5 App-logo" />
                                                         : <p>--</p>}
                                                    </Row>}
                                                </Descriptions.Item>
                                            </Descriptions>
                                        </Col>
                                    </Card>
                                </Row>
                            </Col>)}
                        </Row>
                    </Col>
                </Spin>
                </Row>
            </Drawer>
        );
    }
}

MeetingHistory.propTypes = {
    stageId: PropTypes.string,
    notesCreating: PropTypes.bool,
    visible: PropTypes.bool,
    userId: PropTypes.string
};

export default MeetingHistory;